// ============================================================================
// CSV export — Enterprise-tier feature (gated in ChartPanel).
// ============================================================================

export interface CsvColumn {
  key: string;
  label: string;
}

function escapeCell(value: any): string {
  const text = value === null || value === undefined ? '' : String(value);
  if (/[",\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
}

export function buildCsv(columns: CsvColumn[], rows: Array<Record<string, any>>): string {
  const header = columns.map(c => escapeCell(c.label)).join(',');
  const body = rows.map(row => columns.map(c => escapeCell(row[c.key])).join(','));
  return [header, ...body].join('\n');
}

export function downloadCsv(filename: string, columns: CsvColumn[], rows: Array<Record<string, any>>): void {
  const csv = buildCsv(columns, rows);
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
